import { render, staticRenderFns } from "./BusinessSolutionStep.vue?vue&type=template&id=95af9d7e&scoped=true&"
import script from "./BusinessSolutionStep.vue?vue&type=script&lang=js&"
export * from "./BusinessSolutionStep.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSolutionStep.vue?vue&type=style&index=0&id=95af9d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95af9d7e",
  null
  
)

export default component.exports